var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    enableBackground: "new 0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#007bff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9991,7.82498l-14.23999,7.11005l2.69,5.37l1.63-0.82001v11.69H45.9991V19.52499l1.54999,0.78003l2.69-5.37 L35.9991,7.82498z M37.9991,29.17502h-4v-6h4V29.17502z M43.9991,29.17502h-4v-8h-8v8h-3.91998v-10.69l7.91998-3.96002l8,4 V29.17502z M46.65908,17.62503L35.9991,12.29501l-10.65997,5.33002l-0.89001-1.79004l11.54999-5.77997l11.54999,5.77997 L46.65908,17.62503z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.26131,32.64767c-1.1958-1.59473-3.41602-1.95312-5.05273-0.82031l-9.43988,6.53497 c-0.3761-0.96069-1.1214-1.77448-2.14948-2.19025l-7.52295-3.03613l-9.09717,1.81934v-1.78027h-12v19h12v-1.94531l18.28125,0.9668 l14.55273-13.64355C53.20809,36.26291,53.39217,34.15353,52.26131,32.64767z M16.9991,50.17502h-8v-15h8V50.17502z  M50.46492,36.09396L36.53426,49.15353L18.9991,48.2261V36.99472l8.90283-1.78064l6.96826,2.8125 c0.9585,0.3877,1.42578,1.4834,1.04248,2.44238c-0.34766,0.86816-1.29248,1.35059-2.20215,1.12695l-5.56055-1.39062 l-0.48535,1.93945l5.56104,1.3916c1.82721,0.45386,3.84448-0.57483,4.54401-2.32434 c0.06854-0.17145,0.10699-0.34662,0.14966-0.52118l10.42792-7.21893c0.75-0.51855,1.76562-0.35449,2.31396,0.37598 C51.17928,34.53732,51.09481,35.50314,50.46492,36.09396z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/app_icon.f639f2c4e1da66ff4574b52b0ea485f4.svg";
export { ForwardRef as ReactComponent };